import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p426997442640064512',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
